import * as yup from 'yup';
import { FaqListItem } from '@web/components';

export const component = FaqListItem;

export const schema = yup.object({
  question: yup.string().required(),
  answer: yup.string().required(),
});
